// @ts-ignore
import siteFile from "src/files/site.csv";
import Papa from "papaparse";
import { DEFAULT_SITE } from "src/constants/constants";

export type SiteFile = { site: string } & Record<string, string>;

class ParseService {
  /**
   * Function to parse 'remote' CSV file.
   * @param file The file to parse
   * @param download download set to true indicates that the string you passed as the first
   * argument to parse() is actually a URL from which to download a file and parse its contents
   * @returns {Promise<Array>} An array of data record array which represents a line of data.
   */
  parseCSVFile = async (file: string): Promise<string[]> =>
    new Promise((resolve) => {
      Papa.parse<SiteFile>(file, {
        download: true,
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          resolve(result.data.map(({ site }) => site).filter((site) => site));
        },
      });
    });

  getSite = async (site: string) => {
    const siteRecords = await this.parseCSVFile(siteFile);

    if (siteRecords.includes(site)) {
      return site;
    } else {
      return DEFAULT_SITE;
    }
  };
}

export default new ParseService();
